import { defaultAxios, constants } from "../data/httpWithAxios";

export default {
  getLotteBillingList: function(query) {
    return defaultAxios(constants.contentType.application_json, true)
      .post("/star/ext/api/lotteautocare/billing/list", query)
      .then(response => {
        return response;
      });
  },

  getLotteBillingCall: function(query) {
    return defaultAxios(constants.contentType.application_json, true)
      .post("/star/ext/api/lotteautocare/billing", query)
      .then(response => {
        return response;
      });
  },

  getOrderListLotteBillingCall: function(query) {
    return defaultAxios(constants.contentType.application_json, true)
      .post("/star/ext/api/lotteautocare/billing/bulk", query)
      .then(response => {
        return response;
      });
  },

  billingUpdate: function(form) {
    return defaultAxios(constants.contentType.application_json)
      .post("/star/ext/api/lotteautocare/billing/update", form)
      .then(response => {
        return response;
      });
  }
};

// /star/ext/api/lotteautocare/billing



// WEBPACK FOOTER //
// ./src/api/billing.js